<template>
  <div class="baseSetting-main">
    <div class="title">
      <span class="parent">系统设置 / </span>
      <span>点名规则设置</span>
    </div>
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="点名规则设置" name="first">
          <div class="setting-prepare">
            <div class="setting-title"><b></b>记课时班级设置</div>
            <div class="setting-content">
              <span class="setting-label">缺勤扣除课时</span>
              <el-switch v-model="xmClassMissSign" inactive-text="" active-text="" @change="updateXmClassMissSign">
              </el-switch>
              <div class="setting-tip right">
                <i class="el-icon-warning"></i> 开启后，缺勤的学生扣除课时！
              </div>
            </div>
          </div>
          <div class="setting-ojRank">
            <div class="setting-title"><b></b>不记课时班级设置</div>
            <div class="setting-content" style="margin-bottom:30px">
              <span class="setting-label">出勤学生是否计费</span>
              <el-switch v-model="noXmClassSign" inactive-text="" active-text="" @change="updateNoXmClassSign">
              </el-switch>
              <div class="setting-tip right">
                <i class="el-icon-warning" color="#999"></i> 开启后，班级点名开启计费模式！
              </div>
            </div>
            <div class="setting-content">
              <span class="setting-label">缺勤的学生是否计费</span>
              <el-switch v-model="noXmClassMissSign" inactive-text="" active-text="" @change="updateNoXmClassMissSign">
              </el-switch>
              <div class="setting-tip right">
                <i class="el-icon-warning" color="#999"></i> 开启后，缺勤的学生开启计费模式！
              </div>
            </div>
          </div>

        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>

import {
  api_eduUpdateXmClassMissSign, // 系统设置-个性化设置-点名个则设置-更新记录课时班级缺勤扣除课时设置 
  api_eduUpdateNoXmClassSign, //系统设置-个性化设置-点名个则设置-更新不记录课时班级签到扣除课时设置
  api_eduUpdateNoXmClassMissSign, // 系统设置-个性化设置-点名个则设置-更新记录课时班级缺勤扣除课时设置
} from '@/api/javaApi'

export default {
  name: 'namingRuleSettingVue',
  components: {
    // rulesSetting
  },
  data() {
    return {
      activeName: 'first',
      xmClassMissSign: false, // 记录课时班级缺勤扣除课时设置
      noXmClassSign: false, // 不记录课时班级签到扣除课时设置
      noXmClassMissSign: false, // 不记录课时班级缺勤扣除课时设置
    }
  },
  created() {
    this.xmClassMissSign = this.$store.state.user.schoolInfo.xmClassMissSign;
    this.noXmClassSign = this.$store.state.user.schoolInfo.noXmClassSign;
    this.noXmClassMissSign = this.$store.state.user.schoolInfo.noXmClassMissSign;
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    updateXmClassMissSign() {
      api_eduUpdateXmClassMissSign({
        state: this.xmClassMissSign
      }).then((res) => {
        console.log(res)
        this.$store.state.user.schoolInfo.xmClassMissSign = this.xmClassMissSign;
        this.$message.success('更改成功')
        this.$store.dispatch('freshUserData')
      })
    },
    updateNoXmClassSign() {
      api_eduUpdateNoXmClassSign({
        state: this.noXmClassSign
      }).then((res) => {
        console.log(res)
        this.$store.state.user.schoolInfo.noXmClassSign = this.noXmClassSign;
        this.$message.success('更改成功')
        this.$store.dispatch('freshUserData')
      })
    },
    updateNoXmClassMissSign() {
      api_eduUpdateNoXmClassMissSign({
        state: this.noXmClassMissSign
      }).then((res) => {
        console.log(res)
        this.$store.state.user.schoolInfo.noXmClassMissSign = this.noXmClassMissSign
        this.$message.success('更改成功')
        this.$store.dispatch('freshUserData')
      })
    },
  },
}
</script>
<style scoped lang="scss">
.baseSetting-main {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% + 60px);
  padding: 10px;
  .title {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 20px;
    margin-bottom: 10px;
    background: #ffffff;
    font-size: 14px;
    box-shadow: 0px 0px 4px 0px #f0f4f5;
    border-radius: 5px;
    border: 1px solid #f4f5f9;
    span {
      vertical-align: middle;
      padding-top: 3px;
      &.parent {
        padding-top: 0;
        margin-right: 10px;
        font-size: 16px;
      }
    }
  }
  .container {
    flex: 1;
    // background-color: #fff;
    .el-tabs {
      padding: 10px 20px 20px;
      background-color: #fff;
      border-radius: 5px;
      margin-bottom: 20px;
    }
    .setting-prepare,
    .setting-ojRank,
    .setting-passwordHint {
      width: 100%;
      border: 1px solid #eee;
      border-radius: 5px;
      padding: 15px 15px;
      margin: 10px 0 20px;
      .setting-title {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        b {
          width: 3px;
          height: 14px;
          margin-right: 5px;
          background-color: #1978ff;
          border-radius: 30px;
        }
      }
      .setting-content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 10px;
        span {
          padding-right: 20px;
          font-size: 14px;
          &.setting-label {
            width: 155px;
          }
        }
        .el-switch /deep/ {
          .el-switch__label {
            span {
              font-size: 12px;
            }
          }
        }
      }
      .setting-tip {
        width: 100%;
        padding-top: 20px;
        color: #999;
        font-size: 12px;
        &.right {
          width: auto;
          padding-top: 0;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
